import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { inject } from '@angular/core';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { pipe, switchMap, tap } from 'rxjs';
import { tapResponse } from '@ngrx/component-store';
import { OrganizationService } from '@markant-platform/shared/organization/data-access';
import { OrganizationContact, OrganizationContactState } from '@markant-platform/shared/organization/model';
import { UserService } from '@markant-platform/shared/user/data-access';

export const DEFAULT_ADDRESS = {
  street: '',
  streetNumber: '',
  zipCode: '',
  city: '',
  countryCode: '',
};

const INITIAL_ORGANIZATION_CONTACT_STATE: OrganizationContactState = {
  organization: {
    address: DEFAULT_ADDRESS,
    name: '',
    phone: '',
  },
  contacts: [],
  isLoading: false,
};

export const OrganizationContactStore = signalStore(
  withState(INITIAL_ORGANIZATION_CONTACT_STATE),
  withMethods((store, userService = inject(UserService)) => ({
    getOrganizationContacts: rxMethod<string>(
      pipe(
        switchMap(organizationId =>
          userService.getOrganizationAdmins(organizationId).pipe(
            tapResponse({
              next: (contacts: OrganizationContact[]) => patchState(store, { contacts, isLoading: false }),
              error: _ => patchState(store, { contacts: [], isLoading: false }),
            })
          )
        )
      )
    ),
  })),
  withMethods((store, organizationService = inject(OrganizationService)) => ({
    getOrganizationData: rxMethod<void>(
      pipe(
        tap(_ => patchState(store, { isLoading: true })),
        switchMap(() =>
          organizationService.getCurrentOrganization().pipe(
            tapResponse({
              next: organization => {
                patchState(store, {
                  organization: {
                    address: organization?.address ?? DEFAULT_ADDRESS,
                    name: organization?.name ?? '',
                    phone: organization?.phone ?? '',
                  },
                });
                organization?.id && store.getOrganizationContacts(organization.id);
                !organization?.id && patchState(store, { contacts: [], isLoading: false });
              },
              error: _ =>
                patchState(store, {
                  organization: {
                    address: DEFAULT_ADDRESS,
                    phone: '',
                    name: '',
                  },
                  isLoading: false,
                  contacts: [],
                }),
            })
          )
        )
      )
    ),
  }))
);
